import { get, isEmpty } from 'lodash';
import * as React from 'react';
import { Text, TouchableOpacity, View } from 'react-native';
import { getActions, getItemListClick, getValueBinding } from '../../../shared';
import AvatarImage from './AvatarImage';
import useAvatar, { Props, ReceivedProps } from './hook';

const AvatarItemLayout: React.FC<Props> = (props) => {
  const {
    attrs,
    styles,
    urlImage,
    titleText,
    subTitleText,
    item,
    index,
    onPress,
    placeholderImage,
    isCanvas,
    finalStyle,
  } = props;
  const { attributes } = attrs;

  const { title, cardCover, opacity, backgroundColor, subTitle } = attributes;
  const {
    borderColor,
    borderStyle,
    borderWidth,
    borderRadius,
    image,
    backgroundColor: backgroundImage,
  } = cardCover || {};

  const size = cardCover.styles?.image?.avatarSize || cardCover.size;
  const { enabled = false, titleLineNum, position = 'bottom' } = title || {};
  const {
    enabled: subTitleEnabled = false,
    subTitleLineNum,
    backgroundColor: backgroundColorSubTitle,
    borderRadius: borderRadiusSubTitle,
  } = subTitle || {};
  const lineHeightSubTitle =
    borderRadiusSubTitle >= subTitle?.fontSize * 1.15
      ? subTitle?.fontSize * 1.15
      : borderRadiusSubTitle;

  const handlePress = (id: string, item: Record<string, any>) => {
    const options = {
      itemListClick: getItemListClick(item.record),
    };

    onPress && onPress(getActions(attrs, id), options);
  };

  const bindingValue = getValueBinding('', item, attrs);
  const containerStyle = [
    {
      opacity: finalStyle?.opacity || opacity || 1,
      backgroundColor: finalStyle?.backgroundColor || backgroundColor,
      flexDirection: position === 'top' ? 'column-reverse' : 'column',
      marginRight: finalStyle?.gap || attributes.gap,
      width: size,
    },
    styles.cardWrapper,
  ];

  const getTextStyles = (styleConfig: any, key?: any) => {
    const styleObject = key ? styleConfig[key] : styleConfig;
    return {
      fontFamily: styleObject?.fontFamily || finalStyle.fontFamily,
      fontSize: styleObject?.fontSize || styleConfig?.size,
      color: styleObject?.color || styleConfig?.color,
      fontWeight: finalStyle?.fontWeight?.toString() || '500',
      textAlign: styleObject?.textAlign || finalStyle?.textAlign || 'center',
      ...(styleObject?.lineHeight
        ? { lineHeight: styleObject?.lineHeight }
        : {}),
    };
  };

  // Apply finalStyle to avatar image
  const avatarProps = {
    borderColor: finalStyle?.borderColor || borderColor,
    borderRadius:
      cardCover.styles?.image?.borderRadius ||
      finalStyle?.borderRadius ||
      borderRadius,
    backgroundImage: finalStyle?.backgroundColor || backgroundImage,
    borderStyle: finalStyle?.borderStyle || borderStyle,
    borderWidth: finalStyle?.borderWidth || borderWidth,
    size,
    url: urlImage,
    imageResize: image?.imageResize || 'cover',
    styles,
    placeholderImage,
  };

  return (
    <TouchableOpacity
      onPress={() => {
        handlePress('onPress', {
          record: item,
          indexRecord: index,
        });
      }}
    >
      <View style={containerStyle as any}>
        <TouchableOpacity
          onPress={() => {
            handlePress('cardCover', {
              record: item,
              indexRecord: index,
            });
          }}
        >
          <AvatarImage {...avatarProps} />
        </TouchableOpacity>
        <View>
          {enabled && !isEmpty(titleText) && (
            <Text
              style={[
                {
                  ...getTextStyles(title?.styles?.text),
                },
                styles.cardContent,
              ]}
              numberOfLines={title && titleLineNum > 1 ? 500 : 1}
              onPress={() => {
                handlePress('title', {
                  record: item,
                  indexRecord: index,
                });
              }}
            >
              {isCanvas ? titleText : get(bindingValue, 'title.text')}
            </Text>
          )}

          {subTitleEnabled && !isEmpty(subTitleText) && (
            <Text
              style={[
                {
                  ...getTextStyles(subTitle?.styles?.text),
                  backgroundColor:
                    finalStyle?.backgroundColor || backgroundColorSubTitle,
                  borderRadius: finalStyle?.borderRadius || lineHeightSubTitle,
                  overflow: 'hidden',
                },
                styles.cardContent,
              ]}
              numberOfLines={subTitle && subTitleLineNum > 1 ? 500 : 1}
              onPress={() => {
                handlePress('subTitle', {
                  record: item,
                  indexRecord: index,
                });
              }}
            >
              {isCanvas ? subTitleText : get(bindingValue, 'subTitle.text')}
            </Text>
          )}
        </View>
      </View>
    </TouchableOpacity>
  );
};

const AvatarItem: React.FC<ReceivedProps> = (props) => (
  <AvatarItemLayout {...useAvatar(props)} />
);

export default React.memo(AvatarItem);
